import { Avatar, breakpoints, Col, Tappable, useTheme } from "@rally/ui-kit";
import { say } from "./localization/say.ts";
import { calledBy } from "./me/called.ts";
import { useFace } from "./me/face.ts";
import { usePresent } from "./push/here.ts";
import { goTo } from "./router.ts";
import type { Me } from "./session.ts";

export function Who({ me }: { me: Me }) {
  const theme = useTheme();

  const narrow = theme.isAtMost(breakpoints.phone);
  const called = calledBy(me) ?? me.handle;
  const face = useFace(me.avatar);
  return (
    <Col
      style={{
        flexDirection: "row",
        alignItems: "center",

        gap: theme.space[3],
        zIndex: 31,
      }}
    >
      <Tappable
        onPress={() => goTo("/me/profile")}
        accessibilityRole="button"
        accessibilityLabel={say("you.signedInAs")(me.handle)}
        testID="who"
        style={{
          flexDirection: "row",
          alignItems: "center",
          minWidth: 44,
          minHeight: 44,
          justifyContent: "center",
          paddingVertical: theme.space[2],
          borderRadius: theme.radius.md,
        }}
      >
        <Avatar name={called} src={face} size={narrow ? 32 : 28} present={usePresent(me.account)} />
      </Tappable>
    </Col>
  );
}
